var React = require('react');
var BrandPage = require('./brands-page');

module.exports = React.createClass({

  componentDidMount: function() {
    document.title = "Brands for Women - Ingledew's Shoes";
  },

  render: function() {

    return <BrandPage gender="womens" prefix={CMS.brands.prefixW} title={CMS.brands.titleW}
                      desc={CMS.brands.descW} image={CMS.brands.imgW} />
  }
});